export default {
  methods: {
    async sendError(error, fallback = null) {
      let notice = {
        type: "error",
        message: ""
      };

      if (error.response) {
        let message = null;
        if (error.response.data instanceof Blob) {
          try {
            message = JSON.parse(await error.response.data.text()).error;
          } catch (error) {
            console.error("Empty blob response");
          }
        } else if (error.response.data.errors) {
          let error_messages = Object.keys(error.response.data.errors).map(
            function(error_key) {
              return error.response.data.errors[error_key][0];
            }
          );
          message = error_messages.join(" ");
        } else if (error.response.data.message) {
          message = error.response.data.message;
        } else {
          message = error.response.data.error;
        }
        notice.message = message || fallback;
      } else if (error.error) {
        notice.message = error.error;
      } else if (error) {
        notice.message = error;
      } else {
        notice.message = "Неизвестная ошибка";
      }
      if (!notice.message) return;

      this.$store.commit("addNotice", notice);
    },
    sendAlert(payload) {
      let notice = {
        type: "alert",
        message: null
      };

      if (payload.response) {
        notice.message = payload.response.data.alert;
      } else if (payload.alert) {
        notice.message = payload.alert;
      } else if (payload) {
        notice.message = payload;
      } else {
        notice.message = "Empty alert";
      }
      if (!notice.message) return;

      this.$store.commit("addNotice", notice);
    }
  }
};
